// base component
import { TipComponent } from './tip.component';

// components


export const TipModule = angular.module('topbroker.tip', [])
  .component('tip', TipComponent)
  .name;